import {FieldError} from "react-hook-form";

export const inputClass = (fieldError?: FieldError) => {
  let inputClass = "border p-3 rounded-lg w-full";
  if (fieldError) {
    inputClass += " border-red-600 outline-red-600";
  }
  return inputClass;
};
